(function(window, $, App, undefined) {

App.seriesCreate = {
  initialize: function() {
    var self = this;

    if ( $('.seriesIndexView').length == 0 ) return;

    self.wrapper = $('#gridWrapper');
    self.container = $('#gridContainer');
    this.setupGrid();
    this.bindElements();
    this._gridBorderCheck();
    this._checkColSize();
    this._checkSeriesWindow();
    if (window.location.hash)
      $('[data-hash="'+ window.location.hash.replace('#/','') +'"] .gridMask').click();
  },
  setupGrid: function() {
    this.container.isotope({
      transformsEnabled: false,
      animationEngine: 'jquery',
      animationOptions: {
          duration: 750
      },
      itemSelector: '.gridCell',
      masonry: {
        columnWidth : 299
      },
      resizable: false
    });
  },
  bindElements: function(){
    $('.gridCell', self.wrapper).not('.sponsored').on('mouseenter mouseleave', this._gridCellHover);
    $('.gridCell').find('.gridCellWrapper').on('click', _.bind(this._gridCellExpand, this));
  },
  _checkSeriesWindow: function(){
    var windowX = $(window).width();
    var gridContainerX = $('#gridContainer').width();
    var gridContainerOrigX = $('#gridContainer').width();

    $(window).resize(function(){
      var windowX = $(window).width();
      var gridContainerX = $('#gridContainer').width();

      if ( (gridContainerX <= 768) && (gridContainerX != gridContainerOrigX) ){
        App.seriesCreate._sizeToCol1();
        gridContainerOrigX = $('#gridContainer').width();
        App.seriesCreate._resetLayout();
      }
      else if ( (gridContainerX <= 897) && (gridContainerX != gridContainerOrigX) ){
        App.seriesCreate._sizeToCol2();
        gridContainerOrigX = $('#gridContainer').width();
        App.seriesCreate._resetLayout();
      }
      else {
        if (gridContainerX != gridContainerOrigX){
          App.seriesCreate._sizeToCol2();
          gridContainerOrigX = $('#gridContainer').width();
          App.seriesCreate._resetLayout();
        }
      }
    });
  },
  _checkColSize: function(){
    if( $('#gridContainer').width() <= 768 ){
      App.seriesCreate._sizeToCol1();
    }
    else {
      App.seriesCreate._sizeToCol2();
    }
  },
  _sizeToCol1: function(){
  $('.col2').find('.gridBgInner').each(function(){
    $(this).find('img.col1').css({display: 'block'});
    $(this).find('img.col2').css({display: 'none'});

  });
  $('.col1').find('.gridBgInner').each(function(){
    $(this).find('img.col1').css({display: 'block'});
    $(this).find('img.col2').css({display: 'none'});

  });
  },
  _sizeToCol2: function(){
  $('.col2').find('.gridBgInner').each(function(){
    $(this).find('img.col2').css({display: 'block'});
    $(this).find('img.col1').css({display: 'none'});

  });
  $('.col1').find('.gridBgInner').each(function(){
    $(this).find('img.col1').css({display: 'block'});
    $(this).find('img.col2').css({display: 'none'});

  });
  },
  // Hover Animation effects - can we replace with CSS transitions?
  _gridCellHover: function(e){
    var $t = $(this);
    switch (e.type) {
          case 'mouseenter':
          if ($t.is('.expanded, .expand') || $('#gridWrapper').hasClass('pageLoading')) break;

          if ($t.hasClass('col1')){
              $t.find('.gridBgInner img.col2').hide();

          $t.find('.gridBgInner').css({opacity: 0}).animate({opacity: 1}, 250, 'easeOutQuart');
          $t.find('.gridBgInner img.col1').css({width: '75%', marginTop: '10%'}).animate({width: '99%', marginTop: '0%'}, 150, 'easeOutQuart');
      }

      if ( $t.hasClass('col2') && ($('#gridContainer').width() > 768) ){
          $t.find('.gridBgInner img.col1').css({display: 'none'});
          $t.find('.gridBgInner img.col2').css({display: 'block'});

          $t.find('.gridBgInner').css({opacity: 0}).animate({opacity: 1}, 250, 'easeOutQuart');
          $t.find('.gridBgInner img.col2').css({width: '80%', marginTop: '3%'}).animate({width: '99%', marginTop: '0%'}, 150, 'easeOutQuart');
      }

      if ( $t.hasClass('col2') && ( $('#gridContainer').width() < 768) ){
          $t.find('.gridBgInner img.col2').css({display: 'none'});
          $t.find('.gridBgInner img.col1').css({display: 'block'});

          $t.find('.gridBgInner').css({opacity: 0}).animate({opacity: 1}, 250, 'easeOutQuart');
          $t.find('.gridBgInner img.col1').css({width: '75%', marginTop: '10%'}).animate({width: '99%', marginTop: '0%'}, 150, 'easeOutQuart');
      }
        break;

        case 'mouseleave':
        if ($t.hasClass('col1')){
          $t.find('.gridBgInner').animate({opacity: 0}, 250, 'easeInOutQuart');
        }

        if ( $t.hasClass('col2') && ($('#gridContainer').width() > 768) ){
          $t.find('.gridBgInner').animate({opacity: 0}, 250, 'easeInOutQuart');
        }
        if ( $t.hasClass('col2') && ( $('#gridContainer').width() < 768) ){
          $t.find('.gridBgInner').animate({opacity: 0}, 250, 'easeInOutQuart');
        }
        break;
    }
  },
  _gridCellExpand: function(e){
    var self = this,
    $cell = $(e.target).parents('.gridCell');

    if ($cell.hasClass('sponsored')) {
      window.location.href = $cell.data('url');
      return;
    }

    if(!$cell.hasClass('expanded')){
      pageTitle = $cell.data('title') + ' Series | TED-Ed'

      history.pushState({module:'series'}, pageTitle, '/series/?series=' + $cell.data('hash'));

      $.getScript($cell.data('url'));
      this._gridBorderFade();
      $cell.addClass('expand focused').find('.gridTitle, .gridVideoCount, .gridBackground').animate({opacity: 0}, 200);

      $('meta[property="og:title"]').attr('content', pageTitle);
      $('meta[property="og:url"]').attr('content', window.location.protocol + '//' + window.location.hostname + '/series/?series=' + $cell.data('hash'));
      document.title = pageTitle
      setTimeout(function(){self._gridColExpandTransition()}, 300);
    }
  },

  _gridColExpandTransition: function(){
    $('.gridCell', this.wrapper).removeClass('expanded');
    $('.expand', this.wrapper).addClass('expanded');
    $('.expanded', this.wrapper).removeClass('expand').find('.expandedContent, .expandedFooterBackground').animate({opacity: 1}, 600, 'easeOutQuart');
    this.wrapper.addClass('pageLoading').removeClass('pageLoaded');
    this._resetLayout();
  },

  _gridColCollapseTransition: function($cell){
    $cell.removeClass('expanded');
    this._resetLayout();
  },

  _resetLayout: function(){
    this.container.addClass('pageLoaded').isotope('reLayout', _.bind(this._gridBorderCheck, this));
  },

  // This function will remove all borders & expanded content prior to reorganizing the layout
  _gridBorderFade: function(){
    $('.expanded', self.wrapper).find('.expandedContent, .expandedFooterBackground, .expandedBackground').animate({opacity: 0}, 500);
    $('.gridCellBorderHorizontal, .gridCellBorderVertical', self.wrapper).animate({opacity: 0}, 500, 'easeInOutQuart');
  },

  // Check borders
  _gridBorderCheck: function(){
    $('.focused', this.wrapper).removeClass('focused').find('.gridTitle, .gridVideoCount, .gridBackground, .expandedBackground').animate({opacity: 1}, 500, 'easeOutQuart');
    this.wrapper.removeClass('pageLoading');
    this.wrapper.addClass('pageLoaded');
    this._gridBorderCheckVertical();
    this._gridBorderCheckHorizontal();

    if ($('.expanded').length > 0) {
      $currentExpandedPosition = $('.expanded').offset();
      $('html, body').delay(100).animate({ scrollTop: ($currentExpandedPosition.top) - 75}, 500);
    }
  },

  // This function will detect and fade out vertical boarders depending on X position of grid cell
  _gridBorderCheckVertical: function(){
    $('.gridCell', this.wrapper).each(function(){
      var $currentCell = $(this);
      var $currentCellPosition = $currentCell.position();
      var $gridContainerWidth = $('#gridContainer').width();

      // note: define var for x offset to support dynamic layout
      if ( $currentCellPosition.left >= ( $('#gridContainer').width() - $currentCell.width() - 5 ) && $(this).hasClass('col1') ){
        $(this).find('.gridCellBorderVertical').animate({opacity: 0}, 500);
      }
      else if ( $currentCellPosition.left >= ( $('#gridContainer').width() - $currentCell.width() - 5 ) && $(this).hasClass('col2') ){
        $(this).find('.gridCellBorderVertical').animate({opacity: 0}, 500);
      }
      else if ( $currentCellPosition.left >= ( $('#gridContainer').width() - $currentCell.width() - 20 )  && $(this).hasClass('expanded') ){
        $(this).find('.gridCellBorderVertical').animate({opacity: 0}, 500);
      }
      else {
        $(this).find('.gridCellBorderVertical').animate({opacity: 1}, 750);
      }
    });
  },

  // This function will detect and fade out vertical boarders depending on Y position of grid cell
  _gridBorderCheckHorizontal: function(){
    $('.gridCell', this.wrapper).each(function(){
      var $currentCell = $(this);

      $currentCellPosition = $currentCell.position();
      $currentGridContainer = $('#gridContainer').height();

      $currentOffset = ($currentGridContainer - $currentCellPosition.top);


      if ( $currentOffset < 250 ){
        $(this).find('.gridCellBorderHorizontal').animate({opacity: 0}, 750);
      }
      else {
        $(this).find('.gridCellBorderHorizontal').animate({opacity: 1}, 750);
      }
    });
  }
}

})(window, jQuery, window.App);
